import { Box, FormControl, FormControlLabel, Grid, Radio, RadioGroup, TextField, } from "@material-ui/core";
import React from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { CxQuestion } from "../../entity/entities";
import { changeRadioButton, changeRadioButtonFreeText } from "./inputAnswerSlice";
import { QuestionText } from "./QuestionText";
import { useTranslation } from "react-i18next";
import DATA_QA from "../../util/DataQaAttr";

export function RadioButton(props: {
  pageIndex: number,
  questionIndex: number,
  cxQuestion: CxQuestion,
}) {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  // FIXME 本来はpageIndexを取得するhookを作るべき
  const {
    pageIndex,
    questionIndex,
    cxQuestion,
  } = props;

  const [value, freeText] = useAppSelector(state => {

    const cxQuestionPage = state.inputAnswer.answer.cxAnswerPageDtos[pageIndex];
    const cxAnswer = cxQuestionPage.cxAnswers[questionIndex];

    return [cxAnswer.answerStr, cxAnswer.answerSubStr];
  });

  const handleFreeTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {

    dispatch(changeRadioButtonFreeText({
      pageIndex,
      questionIndex,
      freeText: event.target.value as string,
    }))
  }

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {

    dispatch(changeRadioButton({
      pageIndex,
      questionIndex,
      value: event.target.value as string,
    }));
  };

  const formControlLabels = cxQuestion.cxQuestionOptions.map(cxQuestionOption => {

    let freeTextComponent = <></>;

    // 選択されているオプションがテキスト入力付きの場合
    if (value === cxQuestionOption.optionText) {

      if (cxQuestionOption.withFreeText) {

        const placeholder = cxQuestionOption.freeTextPlaceholder;

        let requiredLabelColor: string;
        let requiredLabelText: string;

        if (cxQuestionOption.freeTextRequired) {
          requiredLabelColor = `#F49494`;
          requiredLabelText = t('common.required');
        } else {
          requiredLabelColor = `#C4C4C4`;
          requiredLabelText = t('common.optional');
        }

        freeTextComponent =
        <React.Fragment>
          {/* 必須、任意ラベル */}
          <Box mt={0} mb={1}>
            <Box textAlign="textBottom" display="inline-block" ml={1} px={2} borderRadius="8px" fontSize="12px" style={{ backgroundColor: requiredLabelColor, }}>{requiredLabelText}</Box>
          </Box>
          <TextField
            fullWidth
            variant="outlined"
            value={freeText}
            onChange={handleFreeTextChange}
            placeholder={placeholder}
            inputProps={{ maxLength: 100, }}
          />
        </React.Fragment>
      }
    }

    return (
      <React.Fragment
        key={cxQuestionOption.id}
      >
        <FormControlLabel
          value={cxQuestionOption.optionText}
          control={
            <Radio
              inputProps={
                {
                  "data-qa": `${DATA_QA.RADIO.RADIO}-${
                    pageIndex + 1
                  }-${questionIndex}-${cxQuestionOption.dispOrder}`,
                } as any
              }
            />
          }
          label={cxQuestionOption.optionText}
          style={{ wordBreak: 'break-word' }}
        />
        {freeTextComponent}
      </React.Fragment>
    );
  });

  return (
    <>
      <QuestionText cxQuestion={cxQuestion} />
      <Box mx={6}>
        <Grid container>
          <Grid item xs={12}>
            <FormControl variant="outlined" fullWidth>
              <RadioGroup
                value={value}
                onChange={handleChange}
              >
                {formControlLabels}
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}
